import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import type { SearchableListItem } from '~/components/workflow/SearchableInputComponent';
import { SearchableInput } from '~/components/workflow/SearchableInputComponent';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import { useMemo } from 'react';
import { Space } from 'antd';
import { Flex } from '../Flex';

export function SelectCountry({
  allowedCountries,
  showCountryCallingCode,
  disabled,
  multiple,
  placeholder,
  ...props
}: {
  allowedCountries?: string[];
  showCountryCallingCode?: boolean;
  multiple?: boolean;
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
}) {
  const options = useMemo(() => {
    const countries = getCountries();
    const options: SearchableListItem[] = [];

    countries.forEach((country) => {
      if (!allowedCountries?.length || allowedCountries.includes(country)) {
        options.push({
          value: country,
          displayValue: (
            <Flex direction="horizontal" alignItems="center" gap="xs" justifyContent="space-between">
              <Space>
                {getUnicodeFlagIcon(country)}
                {country}
              </Space>
              {showCountryCallingCode && `+${getCountryCallingCode(country)}`}
            </Flex>
          ),
        });
      }
    });

    return options;
  }, [allowedCountries, showCountryCallingCode]);

  return (
    <SearchableInput
      disabled={disabled}
      searchList={options}
      multiple={multiple}
      placeholder={placeholder}
      {...props}
    />
  );
}
